import { yupResolver } from "@hookform/resolvers/yup";
import FormHubSelect from "components/Common/Form/FormHubSelect";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import { useTimeSlotsSchedule } from "hooks";
import {
  useChangeRunnerType,
  useCreateRunnerScheduleChanges,
  useListRunnerCurrent,
  useListRunnerFree,
  useUpdateRunnerScheduleChanges,
} from "hooks/allocate-runners/useAllocateRunners";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { MODE_DETAIL } from "./utils";

const CreateScheduleChangeRunner = props => {
  const { isOpenModal, toggleModal, dataDetail, refetchList } = props;

  const [currentWeekOnly, setCurrentWeekOnly] = useState(true);

  const onCreateSuccess = () => {
    toggleModal();
    refetchList();
  };

  // runnerFreeParams
  const [timeSlotsScheduleParams, setTimeSlotsScheduleParams] = useState({
    date: null,
    hub_id: null,
    run: false,
  });

  const { data: timeSlots, refetch: fetchTimeSlots } = useTimeSlotsSchedule({
    params: timeSlotsScheduleParams,
  });

  const onUpdateSuccess = () => {
    toggleModal();
    refetchList();
  };

  const { isLoading: isLoadingCreate, mutate: mutateCreate } =
    useCreateRunnerScheduleChanges(onCreateSuccess);

  const { isLoading: isLoadingUpdate, mutate: mutateUpdate } =
    useUpdateRunnerScheduleChanges(onUpdateSuccess);

  const { t } = useTranslation(["allocateRunner"]);

  /* ================================== START INIT STATE ==================================== */

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  /* ================================ END FUNCTION HANDLER ================================= */

  const schema = yup.object().shape({
    type: yup.object().required(
      t("form.validate.select", {
        title: t("form.schedule_change_runner_type"),
      })
    ),
    timeslot_ids: yup.array().min(
      1,
      t("form.validate.select", {
        title: t("form.timeslot_ids"),
      })
    ),
    runner_id_current: yup
      .object()
      .required(
        t("form.validate.select", {
          title: t("form.runner_id_current"),
        })
      )
      .test(
        "dulipcateRunnerCurrent",
        "Runner hiện tại không được trùng với Runner thay thế",
        (runner, e) => {
          if (runner && runner.value === e?.parent?.runner_id?.value) {
            return false;
          }
          return true;
        }
      )
      .nullable(),
    runner_id: yup
      .object()
      .required(
        t("form.validate.select", {
          title: t("form.runner_id"),
        })
      )
      .test(
        "dulipcateRunner",
        "Runner thay thế không được trùng với Runner hiện tại",
        (runner, e) => {
          if (runner && runner.value === e?.parent?.runner_id_current?.value) {
            return false;
          }
          return true;
        }
      )
      .nullable(),
    note: yup.string().nullable(),
    hub_id: yup
      .object()
      .nullable()
      .required(t("form.validate.select", { title: t("form.hub_id") })),
  });

  const { refetch: fetchListChangeRunnerType, data: listChangeRunnerType } =
    useChangeRunnerType();

  // runnerFreeParams
  const [runnerFreeParams, setRunnerFreeParams] = useState({
    type: null,
    date: null,
    timeslot_ids: null,
    hub_id: null,
    run: false,
  });

  const {
    refetch: fetchListRunnerFree,
    data: listRunnerFree,
    isFetching: isFetchingRunnerFree,
  } = useListRunnerFree({
    payload: { params: runnerFreeParams },
  });

  // runnerarams
  const [runnerParams, setRunnerParams] = useState({
    type: null,
    date: null,
    timeslot_ids: null,
    hub_id: null,
    run: false,
  });

  const {
    refetch: fetchListRunnerCurrent,
    data: listRunnerCurrent,
    isFetching: isFetchingRunnerCurrent,
  } = useListRunnerCurrent({
    payload: { params: runnerParams },
  });

  const initDefaultValues = {
    type: null,
    date: [],
    timeslot_ids: [],
    runner_id_current: undefined,
    runner_id: undefined,
    hub_id: undefined,
  };

  useEffect(() => {
    if (runnerFreeParams && runnerFreeParams.run && runnerFreeParams.hub_id) {
      fetchListRunnerFree();
    }
  }, [runnerFreeParams]);

  useEffect(() => {
    if (runnerParams && runnerParams.run && runnerParams.hub_id) {
      fetchListRunnerCurrent();
    }
  }, [runnerParams]);

  useEffect(() => {
    if (
      timeSlotsScheduleParams &&
      timeSlotsScheduleParams.run &&
      timeSlotsScheduleParams.hub_id
    ) {
      fetchTimeSlots();
    }
  }, [timeSlotsScheduleParams]);

  useEffect(() => {
    if (listChangeRunnerType?.length > 0) {
      setValue("type", listChangeRunnerType?.[0]);
    }
  }, listChangeRunnerType);

  useEffect(() => {
    fetchListChangeRunnerType();
  }, []);

  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail) {
        setValue(
          "type",
          listChangeRunnerType?.find(
            item => item.value == dataDetail?.object_type
          ) || null
        );
        setValue("date", [new Date(dataDetail?.from_date)]);
        // setValue(
        //   "timeslot_ids",
        //   timeSlots?.filter(item =>
        //     dataDetail?.timeSlot.find(s => Number(s.id) === Number(item.value))
        //   ) || [],
        //   { shouldValidate: true }
        // );
        setValue(
          "timeslot_ids",
          dataDetail?.timeSlot.map(item => {
            return {
              value: item.id,
              label: item.name,
            };
          }) || [],
          { shouldValidate: true }
        );
        const runner = {
          value: dataDetail?.runner_id,
          label: dataDetail?.runner_name,
        };
        const runnerCurrent = {
          value: dataDetail?.runner_id_current,
          label: dataDetail?.runner_name_current,
        };
        setValue("note", dataDetail?.note);
        setValue("hub_id", null);

        setTimeout(() => {
          setValue("runner_id", runner, { shouldValidate: true });
          setValue("runner_id_current", runnerCurrent, {
            shouldValidate: true,
          });
        });
      } else {
        reset();
        setValue("type", listChangeRunnerType?.[0]);
        setValue("date", [new Date()]);
        setValue("runner_id_current", null);
        setValue("runner_id", null);
        setValue("note", "");
        setValue("hub_id", null);
      }
      setTimeout(() => {
        setRunnerFreeParams(prev => {
          return {
            ...prev,
            run: true,
          };
        });
        setRunnerParams(prev => {
          return {
            ...prev,
            run: true,
          };
        });
        setTimeSlotsScheduleParams(prev => {
          return {
            ...prev,
            run: true,
          };
        });
      });
    } else {
      setRunnerFreeParams(prev => {
        return {
          ...prev,
          hub_id: null,
          run: false,
        };
      });
      setRunnerParams(prev => {
        return {
          ...prev,
          hub_id: null,
          run: false,
        };
      });
      setTimeSlotsScheduleParams(prev => {
        return {
          ...prev,
          hub_id: null,
          run: false,
        };
      });
      setCurrentWeekOnly(false);
    }
  }, [isOpenModal, dataDetail]);

  const mainForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = mainForm;

  const typeChange = watch("type");
  const dateChange = watch("date");
  const timeSlot = watch("timeslot_ids");
  const hubWatch = watch("hub_id");

  useEffect(() => {
    if (hubWatch) {
      setValue("timeslot_ids", []);
      setTimeSlotsScheduleParams(prev => ({
        ...prev,
        hub_id: hubWatch.value,
      }));
      setValue("runner_id", null);
      setRunnerFreeParams(prev => {
        return {
          ...prev,
          hub_id: hubWatch.value,
        };
      });
      setValue("runner_id_current", null);
      setRunnerParams(prev => {
        return {
          ...prev,
          hub_id: hubWatch.value,
        };
      });
    }
  }, [hubWatch]);

  useEffect(() => {
    setRunnerFreeParams(prev => {
      return {
        ...prev,
        type: typeChange?.value,
      };
    });
    setRunnerParams(prev => {
      return {
        ...prev,
        type: typeChange?.value,
      };
    });
    if (typeChange?.value == 10 || typeChange?.value == 20) {
      setCurrentWeekOnly(true);
    } else {
      setCurrentWeekOnly(false);
    }
  }, [typeChange]);

  useEffect(() => {
    setRunnerFreeParams(prev => {
      return {
        ...prev,
        date: moment(dateChange[0]).format("YYYY-MM-DD"),
      };
    });
    setRunnerParams(prev => {
      return {
        ...prev,
        date: moment(dateChange[0]).format("YYYY-MM-DD"),
      };
    });
    setTimeSlotsScheduleParams(prev => {
      return {
        ...prev,
        date: dateChange[0]
          ? moment(dateChange[0]).format("YYYY-MM-DD")
          : undefined,
      };
    });
  }, [dateChange]);

  useEffect(() => {
    setRunnerFreeParams(prev => {
      return {
        ...prev,
        timeslot_ids: timeSlot.map(item => item?.value).join(",") || 0,
      };
    });
    setRunnerParams(prev => {
      return {
        ...prev,
        timeslot_ids: timeSlot.map(item => item?.value).join(",") || 0,
      };
    });
  }, [timeSlot]);

  const onSubmit = data => {
    const finalData = {
      runner_id: data?.runner_id?.value,
      runner_id_current: data?.runner_id_current?.value,
      object_type: data?.type?.value,
      from_date: moment(data?.date[0]).format("YYYY-MM-DD"),
      timeslot_ids: data?.timeslot_ids?.map(item => item.value).join(","),
      note: data?.note,
      hub_id: data?.hub_id?.value,
    };
    if (dataDetail) {
      mutateUpdate({
        id: dataDetail?.id,
        ...finalData,
      });
    } else {
      mutateCreate(finalData);
    }
  };

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>
          {t("title.change_schedule")}
        </ModalHeader>
        <ModalBody>
          <Row className="row-cols-1 row-cols-md-1">
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="type">{t("form.type")} </Label>
                <Controller
                  control={control}
                  name="type"
                  render={({ field }) => (
                    <Select
                      {...field}
                      isDisabled={dataDetail?.mode === MODE_DETAIL.VIEW}
                      placeholder={t("placeholder.select", {
                        title: t("form.type"),
                      })}
                      onChange={value => {
                        field.onChange(value);
                        setValue("runner_id", null);
                        setValue("runner_id_current", null);
                      }}
                      options={listChangeRunnerType}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.type && (
                  <MessageFormValidate error={errors.type.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="date">
                  {t("form.date")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="date"
                  render={({ field }) => (
                    <Flatpickr
                      {...field}
                      disabled={dataDetail?.mode === MODE_DETAIL.VIEW}
                      className={`form-control d-block Flatpickr__Input ${formValidate(
                        errors,
                        touchedFields,
                        "date"
                      )}`}
                      placeholder="DD/MM/YYYY"
                      options={{
                        altInput: true,
                        altFormat: "d/m/Y",
                        dateFormat: "d/m/Y",
                        minDate:
                          dataDetail?.mode !== MODE_DETAIL.VIEW && "today",
                        maxDate:
                          dataDetail?.mode !== MODE_DETAIL.VIEW &&
                          currentWeekOnly &&
                          moment().endOf("isoweek").toDate(),
                        locale: {
                          firstDayOfWeek: 1,
                        },
                      }}
                      onChange={value => {
                        field.onChange(value);
                        setValue("runner_id", null);
                        setValue("runner_id_current", null);
                        setValue("timeslot_ids", []);
                      }}
                    />
                  )}
                />
                {errors.date && (
                  <MessageFormValidate error={errors.date.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormHubSelect
                isMyHubOnly
                isRequired
                mainForm={mainForm}
                fieldName="hub_id"
                t={t}
                title={t("form.hub_id")}
              />
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="timeslot_ids">
                  {t("form.timeslot_ids")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="timeslot_ids"
                  render={({ field }) => (
                    <Select
                      isClearable
                      isDisabled={
                        dataDetail?.mode === MODE_DETAIL.VIEW || !hubWatch
                      }
                      {...field}
                      isMulti
                      placeholder={t("placeholder.select", {
                        title: t("form.timeslot_ids"),
                      })}
                      onChange={value => {
                        field.onChange(value);
                        setValue("runner_id", null);
                        setValue("runner_id_current", null);
                      }}
                      options={timeSlots}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.timeslot_ids && (
                  <MessageFormValidate error={errors.timeslot_ids.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="runner_id_current">
                  {t("form.runner_id_current")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="runner_id_current"
                  render={({ field }) => (
                    <Select
                      isClearable
                      isDisabled={
                        dataDetail?.mode === MODE_DETAIL.VIEW || !hubWatch
                      }
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.runner_id_current"),
                      })}
                      options={listRunnerCurrent || []}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.runner_id_current && (
                  <MessageFormValidate
                    error={errors.runner_id_current.message}
                  />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="runner_id">
                  {t("form.runner_id")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="runner_id"
                  render={({ field }) => (
                    <Select
                      isClearable
                      isDisabled={
                        isFetchingRunnerFree ||
                        dataDetail?.mode === MODE_DETAIL.VIEW ||
                        !hubWatch
                      }
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.runner_id"),
                      })}
                      options={listRunnerFree || []}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.runner_id && (
                  <MessageFormValidate error={errors.runner_id.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="note">{t("form.note")}</Label>
                <textarea
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    "note"
                  )}`}
                  disabled={dataDetail?.mode === MODE_DETAIL.VIEW}
                  placeholder={t("placeholder.enter", {
                    title: t("form.note"),
                  })}
                  {...register("note")}
                />
                {errors.note && (
                  <MessageFormValidate error={errors.note.message} />
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row className="justify-content-end">
            <Col className="col-auto">
              {dataDetail?.mode !== MODE_DETAIL.VIEW && (
                <Button
                  color="primary"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                  disabled={!watch("runner_id") || !watch("runner_id_current")}
                >
                  <i className="bx bx-save label-icon"></i>
                  {dataDetail?.mode !== MODE_DETAIL.UPDATE
                    ? "Tạo lịch"
                    : "Cập nhật"}
                </Button>
              )}
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

CreateScheduleChangeRunner.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
};

CreateScheduleChangeRunner.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
};

export default CreateScheduleChangeRunner;
